import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    GetLtlRppDetailsResponse,
    GetLtlRppParams,
    GetLtlRppResponse,
    GetLtlRppBidResponse,
    RPPCashFlowsListResponseT,
    RPPExportExcelPayloadT,
    RPPExportExcelResponseT,
    RPPListParamsT,
    RPPListResponseT,
    RPPOrdersListParamsT,
    RPPOrdersListResponseT,
    RPPPayloadT,
    RPPResponseT,
    RppSubmitPayload,
    GetLtlRppCostComparisonResponse,
} from '@/core/types/rpp.types'

export class RPPRepository {
    getCashFlows(): Promise<AxiosResponse<RPPCashFlowsListResponseT>> {
        return http.get(`/cabinet/api/cash-flows`)
    }

    getRPPOrdersList(params: RPPOrdersListParamsT): Promise<AxiosResponse<RPPOrdersListResponseT>> {
        return http.get(`/cabinet/api/v2/ftl/carrier/orders`, { params })
    }

    getRPPList(params: RPPListParamsT): Promise<AxiosResponse<RPPListResponseT>> {
        return http.get(`/cabinet/api/payment-by-supplier`, { params })
    }

    getRPP(id: number): Promise<AxiosResponse<RPPResponseT>> {
        return http.get(`/cabinet/api/payment-by-supplier/${id}`)
    }

    createRPP(payload: RPPPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/payment-by-supplier', payload)
    }

    submitRpp(payload: RppSubmitPayload): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/payment-by-supplier/status`, payload)
    }

    editRPP(payload: RPPPayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/payment-by-supplier/${payload.id}`, payload)
    }

    changeCompany(id: number, companyId: number): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/payment-by-supplier/change-company/${id}`, { companyId })
    }

    changeStatusRPP(rpp_id: number, status_code: string): Promise<AxiosResponse<void>> {
        const params = {
            status_code,
        }

        return http.put(`/cabinet/api/payment-by-supplier/status/${rpp_id}`, params)
    }

    exportExcel(params: RPPExportExcelPayloadT): Promise<RPPExportExcelResponseT> {
        return http.get(`/cabinet/api/payment-by-supplier/export`, { params, responseType: 'blob' })
    }

    exportLTLExcel(params: RPPExportExcelPayloadT): Promise<RPPExportExcelResponseT> {
        return http.get(`/cabinet/api/payment-by-suppliers/trip/export`, {
            params,
            responseType: 'blob',
        })
    }

    exportLtlByIdExcel(id: number): Promise<RPPExportExcelResponseT> {
        return http.get(`/cabinet/api/payment-by-suppliers/trip/${id}/export`, {
            responseType: 'blob',
        })
    }

    deleteRpp(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/payment-by-supplier/${id}`)
    }

    getLtlRppList(params: GetLtlRppParams): Promise<AxiosResponse<GetLtlRppResponse>> {
        return http.get('/cabinet/api/payment-by-suppliers/trip', { params })
    }

    getLtlRppCostComparison(id: number): Promise<AxiosResponse<GetLtlRppCostComparisonResponse>> {
        return http.get(`/tms/api/trips/${id}/cost-comparison`)
    }

    getLtlRpp(ltl_rpp_id: number): Promise<AxiosResponse<GetLtlRppDetailsResponse>> {
        return http.get(`/cabinet/api/payment-by-suppliers/trip/${ltl_rpp_id}`)
    }

    getLtlRppBid(trip_id: number): Promise<AxiosResponse<GetLtlRppBidResponse>> {
        return http.get(`/tms/api/bid/${trip_id}/get-bid-detail`)
    }
}
